import { Injectable } from "@angular/core";
import { Subject } from "rxjs";
import { ILayerRequest } from "../../interfaces/i-layer-request";
import { ILayerResponse } from "../../interfaces/i-layer-response";
import { IEditLayerRequest } from "../../interfaces/i-edit-layer-request";

@Injectable({
  providedIn: "root",
})
export class LayerCommunicatorService {
  private shareLayerRequestSubject = new Subject<ILayerRequest>();

  public shareLayerRequest$ = this.shareLayerRequestSubject.asObservable();

  private shareLayerResponseSubject = new Subject<ILayerResponse>();

  public shareLayerResponse$ = this.shareLayerResponseSubject.asObservable();

  private removeLayerRequestSubject = new Subject<ILayerRequest>();

  public removeLayerRequest$ = this.removeLayerRequestSubject.asObservable();

  private removeLayerResponseSubject = new Subject<ILayerResponse>();

  public removeLayerResponse$ = this.removeLayerResponseSubject.asObservable();

  private editLayerRequestSubject = new Subject<IEditLayerRequest>();

  public editLayerRequest$ = this.editLayerRequestSubject.asObservable();

  private editLayerResponseSubject = new Subject<ILayerResponse>();

  public editLayerResponse$ = this.editLayerResponseSubject.asObservable();

  shareLayerRequest(request: ILayerRequest) {
    this.shareLayerRequestSubject.next(request);
  }

  shareLayerResponse(response: ILayerResponse) {
    this.shareLayerResponseSubject.next(response);
  }

  removeLayerRequest(request: ILayerRequest) {
    this.removeLayerRequestSubject.next(request);
  }

  removeLayerResponse(response: ILayerResponse) {
    this.removeLayerResponseSubject.next(response);
  }

  editLayerRequest(request: IEditLayerRequest) {
    this.editLayerRequestSubject.next(request);
  }

  editLayerResponse(response: ILayerResponse) {
    this.editLayerResponseSubject.next(response);
  }
}
